<template>
  <div>
    <van-form class="q_mar_b100px">
      <van-field v-if="!phonedb" v-model="phone" label="手机号码" clearable placeholder="请输入手机号码" input-align="right" disabled />
      <van-field v-if="phonedb" v-model="phone" label="手机号码" clearable placeholder="请输入手机号码" input-align="right" />
      <van-field v-model="code" type="number" center clearable label="短信验证码" placeholder="请输入短信验证码" input-align="right">
        <template #button>
          <van-button size="mini" type="primary" color="#FF5733" @click="sendCode" :disabled="isSendCode">{{
              codeText
            }}
          </van-button>
        </template>
      </van-field>
      <van-field v-model="password" label="新密码" :type="passwordType" clearable placeholder="请输入6-20位密码" input-align="right">
        <template slot="right-icon">
                      <span @click="switchPasswordType">
                           <van-icon name="closed-eye" v-if="passwordType==='password'"/>
                           <van-icon name="eye" v-else />
                      </span>
        </template>
      </van-field>
      <van-field v-model="password1" :type="passwordType1" clearable label="确认新密码" placeholder="请再次输入新密码" input-align="right">
        <template slot="right-icon">
                      <span @click="switchPasswordType1">
                           <van-icon name="closed-eye" v-if="passwordType1==='password'"/>
                           <van-icon name="eye" v-else />
                      </span>
        </template>
      </van-field>
    </van-form>
    <div class="q_center q_mar_t30px">
      <van-button class="q_btn_min" round color="#FF5733" @click="submitFind" :loading="buttonLoading"
                  :disabled="buttonLoading"
                  loading-type="spinner"
                  loading-text="正在提交">确 认
      </van-button>
    </div>
  </div>
</template>

<script>
import {validatePhoneNumber} from "@/utils/validate";
import {find, getCode, getLoginUser} from "@/api/login";
import {Encrypt} from "@/utils/crypto";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Setpassword',
  props: {
    msg: String
  },
  data() {
    return {
      passwordType:'password',
      passwordType1:'password',
      phonedb:false,
      phone: '',
      code: '',
      password: '',
      password1: '',
      //发送验证码是否显示
      isSendCode: false,
      //验证码重新发送秒
      second: 60,
      //验证码显示文本
      codeText: '发送验证码',
      buttonLoading: false,
      user:{}
    }
  },
  created() {
    wxCloseShare()
    var tag = this.$route.query.tag;
      if (tag != 'tag'){
        getLoginUser().then(res=>{
          this.user = res.data
          this.phone = res.data.phone
        })
      }else {
        this.phonedb = true
      }

  },
  methods: {
    /**
     * 发送验证码
     */
    sendCode() {
      if (!this.phone) {
        this.$modal.alert('请输入手机号')
        return
      }
      if (!validatePhoneNumber(this.phone)) {
        this.$modal.alert('手机号格式有误')
        return
      }
      //发送验证码
      this.isSendCode = true
      let data = {'phone': this.phone, 'type': '2'}
      this.$modal.loading('正在发送')
      getCode(data).then(res => {
        this.$modal.closeLoading()
        this.$modal.success("发送成功")
        let second = this.second
        let timer = setInterval(() => {
          second--
          this.timeFun(second, timer)
        }, 1000)
      }).catch(()=>{
        this.$modal.closeLoading()
      }).finally(() => {
        this.isSendCode = false
      })
    },
    /**
     * 倒计时
     * @param timer
     */
    timeFun(second, timer) {
      setTimeout(() => {
        if (second != 0) {
          this.isSendCode = true
          this.codeText = second + '秒后重新发送'
        } else {
          this.isSendCode = false
          this.codeText = '发送验证码'
          clearInterval(timer)
        }
      }, 0)
    },
    /**
     * 提交注册
     */
    submitFind() {
      if (!this.phone) {
        this.$modal.alert('请输入手机号')
        return
      }
      if (!validatePhoneNumber(this.phone)) {
        this.$modal.alert('手机号格式有误')
        return
      }
      if (!this.code) {
        this.$modal.alert('请输入短信验证码')
        return
      }
      if (!this.password || this.password.length < 6 || this.password.length > 16) {
        this.$modal.alert('请输入6-16位密码')
        return
      }
      //特殊符号包含（. _ ~ ! @ # $ ^ & *）
      //密码必须由字母、数字、特殊符号组成，区分大小写
      const rule = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{6,16}$/;
      if (rule.test(this.password)) {
        console.log("密码验证通过");
      } else {
        this.$modal.alert('密码必须由6-16位字母、数字、特殊符号(. _ ~ ! @ # $ ^ & *)组成');
        return;
      }
      if (!this.password1) {
        this.$modal.alert('请再次输入密码')
        return
      }
      if (this.password != this.password1) {
        this.$modal.alert('两次密码输入不一致，请重新输入')
        return
      }

      this.buttonLoading = true
      let data = {'phone': this.phone, 'password': Encrypt(this.password), 'code': this.code}
      //找回用户
      find(data).then(res => {
        this.$modal.success("操作成功")
        this.reset()
        setTimeout(() => {
          this.$router.push({
            path: '/mine/sign'
          });
        }, 1500);
      }).finally(() => {
        this.buttonLoading = false
      })

    },
    /**
     * 重置表单
     */
    reset() {
      this.phone = ''
      this.code = ''
      this.password = ''
      this.password1 = ''
      this.isSendCode = false
      this.second = 5
      this.codeText = '发送验证码'
      this.buttonLoading = false
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchPasswordType1() {
      this.passwordType1 = this.passwordType1 === 'password' ? 'text' : 'password'
    },
  },
}
</script>
<style scoped="scoped">
.van-button--mini {
  margin-left: 5px;
  float: right;
}
</style>
